import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { AuthRouter } from './routes/AuthRouter';
import { PrivateRouter } from './routes/PrivateRouter';
import { authMe } from './actions/auth';
import { GlobalLoader } from './components/private/pages/loader/GlobalLoader';
import { Sidebar } from './components/private/shared/sidebar/Sidebar';
import { Header } from './components/private/shared/header/Header';
import { PageLayout } from './components/private/shared/pageLayout/PageLayout';

export const Finan = () => {

    const { id, token  } = useSelector(state => state.auth);
    const { adminEmailVerified } = useSelector(state => state.company);
    const { sidebarCollapsed } = useSelector(state => state.ui);

    const dispatch = useDispatch();
    const [isBootstrappingSession, setIsBootstrappingSession] = useState(() => {
        try {
            const storedAuth = localStorage.getItem('finanAuth');
            if (!storedAuth) return false;
            const parsedAuth = JSON.parse(storedAuth);
            return Boolean(parsedAuth?.token);
        } catch (error) {
            localStorage.removeItem('finanAuth');
            return false;
        }
    });

    useEffect(() => {
        if(id && token){
            localStorage.setItem('finanAuth', JSON.stringify({ id, token }));
        }
    }, [id, token]);

    useEffect(() => {
        const htmlElement = document.documentElement;
        if (sidebarCollapsed) {
            htmlElement.classList.add('minimenu');
        } else {
            htmlElement.classList.remove('minimenu');
        }
    }, [sidebarCollapsed]);

    useEffect(() => {
        if (!isBootstrappingSession) return;

        const restoreSession = async () => {
            try {
                const storedAuth = localStorage.getItem('finanAuth');
                if (!storedAuth) return;

                const parsedAuth = JSON.parse(storedAuth);
                if(parsedAuth?.token){
                    await dispatch( authMe( parsedAuth.token ) );
                }
            } catch (error) {
                localStorage.removeItem('finanAuth');
            } finally {
                setIsBootstrappingSession(false);
            }
        };

        restoreSession();
    }, [dispatch, isBootstrappingSession]);

    if (isBootstrappingSession) {
        return (
            <Router>
                <div className="d-flex justify-content-center align-items-center vh-100">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </Router>
        );
    }

    return (
        <>            
            <Router>
                {
                    id && token && adminEmailVerified
                    ?
                        <>
                            <Sidebar />
                            <Header />
                            <PageLayout>
                                <PrivateRouter />
                            </PageLayout>
                            <GlobalLoader />
                        </>

                    :
                        <AuthRouter />
                }
            </Router>
        </>
    )
}
